<template>
  <div class="chip-tolltip">
    <ContentChip
      v-if="textLabel"
      :color="color"
      :leading-icon="leadingIcon"
      :text-label="textLabel"
      :leading-img="leadingImg"
    />
    <div
      v-if="tooltipContent"
      class="chip-tolltip-tooltip"
    >
      <p>{{ tooltipContent }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "ChipTooltip",

  props: {
    leadingIcon: {
      type: String,
      default: null,
    },
    textLabel: {
      type: String,
      default: null,
    },
    leadingImg: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: null,
    },
    tooltipContent: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/chip-tool-tip.scss";
</style>